import { ProductStatus } from '../enums/product-status.enum';

export const ProductStatusText: Record<ProductStatus, string> = {
  [ProductStatus.Inactive]: "Ngưng hoạt động",
  [ProductStatus.Active]: "Đang hoạt động"
};

export const ProductStatusColor: Record<ProductStatus, string> = {
  [ProductStatus.Inactive]: "text-danger",
  [ProductStatus.Active]: "text-success"
};
